{
  "RESET_PASSWORD": {
    "TITLE": "Reset password",
    "DESCRIPTION": "Enter the email address you use to log in to Chatwoot to get the password reset instructions.",
    "GO_BACK_TO_LOGIN": "If you want to go back to the login page,",
    "EMAIL": {
      "LABEL": "E-post",
      "PLACEHOLDER": "Skriv inn din e-post.",
      "ERROR": "Vennligst skriv inn en gyldig e-postadresse."
    },
    "API": {
      "SUCCESS_MESSAGE": "Link for å tilbakestille passordet ditt er sendt til e-postadressen din.",
      "ERROR_MESSAGE": "Could not connect to Woot server. Please try again."
    },
    "SUBMIT": "Send"
  }
}
